import { Suspense, useEffect, useRef, useState } from 'react';

// Mount once near the viewport; keep mounted to preserve drafts and tab state.
export default function DeferredOrbitSection({ id, label, children }) {
  const element = useRef(null);
  const [ready, setReady] = useState(false);
  useEffect(() => {
    if (ready || !window.IntersectionObserver) return;
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) {
        setReady(true);
        observer.disconnect();
      }
    }, { rootMargin: '240px 0px' });
    observer.observe(element.current);
    return () => observer.disconnect();
  }, [ready]);
  return <div id={id} ref={element} className="orbit-deferred">
    {ready ? <Suspense fallback={<div className="orbit-deferred-placeholder" role="status">Loading {label}…</div>}>{children}</Suspense>
      : <div className="orbit-deferred-placeholder"><h2>{label}</h2><button onClick={() => setReady(true)}>Open {label}</button></div>}
  </div>;
}
